import type { DocumentData } from "firebase/firestore";
import BaseApi from "../core/BaseApi";
import SectionModel, { type SectionModelData } from "./SectionModel";

export default class SectionsApi extends BaseApi<
  SectionModel,
  SectionModelData
> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}sections`;
  }

  get store() {
    return this.stores.sectionsStore;
  }

  fromFirestore(res: DocumentData): SectionModel {
    return new SectionModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
